import React, { Component } from 'react';
import Firebase from 'firebase';
import 'firebase/functions';
import Moment from 'moment';
import Connector from '../../data/Connector';
import HelperBusiness from '../../helper/Business';
import * as ROUTES from '../../constants/routes';
import { Link, withRouter } from 'react-router-dom';
import HelperPage from '../../helper/Page';
import EventEmitter from '../../helper/Emitter';
import Navigation from '../../components/Navigation';
import Header from '../../components/Headers/form';
import ListEmpty from '../../components/List/empty';
import InputClient from '../../components/Form/client';
import InputText from '../../components/Form/input-text';
import InputRadio from '../../components/Form/radio';
import FormCard from '../../components/Form/card';
import InputDate from '../../components/Form/input-date';
import Loader from '../../components/Form/loader';
import WidgetFormInfo from '../../components/Widgets/forminfo';
import WidgetCard from '../../components/Widgets/card';
import ModalMessageSimple from '../../components/Modals/message-simple';
import { withTranslation } from "react-i18next";
import lang from 'i18next';
import { AuthUserContext, withAuthorization } from '../../components/Session';



class PayInvoicePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: '',
      clients: global.clients,
      products: [],
      product: null,
      client: null,
      type: 'sessions',
      log: global.userLog,
      loading: false,
      card: false,
      valuesCard: ['', '', '', '', ''],
      errorCard: [false, false, false, false, false],
      trial: 'notset',
      search: '',
      back: ROUTES.BILLING,
      method: 'card',
      token: '',
      notes: '',
      invoice: '',
      item: null,
      date: Moment().format('X'),
      dateChange: false,
      showModalClients: false,
      showModalBasic: false,
      showModalConfirm: false,
      showModalStock: false,
    };
  }


  componentDidMount() {
    HelperPage.initializeForm('Pay an Invoice - PT Mate')
    this._isMounted = true

    EventEmitter.subscribe('userLoaded', (event) => this.configureData())
    EventEmitter.subscribe('clientsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('invoicesLoaded', (event) => this.configureData())
    EventEmitter.subscribe('paymentsLoaded', (event) => {
      this.configureData()
      if(this.state.loading) {
        global.message = lang.t('messaging:message.paymentsuccessful')
        setTimeout(() => {
          EventEmitter.dispatch('updateBadges', 'payment');
        }, 1000);
        //this.props.history.push(this.state.back)
        if(this.state.loading) {
          this.topUpClient()
        }
      }
    })
    EventEmitter.subscribe('logLoaded', (event) => this.configureLog())
    EventEmitter.subscribe('productsLoaded', (event) => this.configureData())
    EventEmitter.subscribe('tokenLoaded', (event) => this.setState({token: global.clientToken}))
    this.configureData()
  }


  componentWillUnmount() {
    this._isMounted = false
    this.setState({
      loading: false
    })
    EventEmitter.unsubscribe('userLoaded', () => {})
    EventEmitter.unsubscribe('clientsLoaded', () => {})
    EventEmitter.unsubscribe('invoicesLoaded', () => {})
    EventEmitter.unsubscribe('paymentsLoaded', () => {})
    EventEmitter.unsubscribe('logLoaded', () => {})
    EventEmitter.unsubscribe('productsLoaded', () => {})
    EventEmitter.unsubscribe('tokenLoaded', () => {})
  }


  configureData() {
    if(this._isMounted) {
      var arr = this.props.location.pathname.split('/')
      var id = ''
      var item = null
      var product = null
      var invoice = ''
      var products = []
      var back = ROUTES.BILLING
      var card = false

      for(var inv of global.invoices) {
        if(inv.id === arr[arr.length-1]) {
          invoice = inv.id
          id = inv.data.client
          item = inv
        }
      }

      back = global.currentPage
      if(global.linkCli !== '') {
        back = global.linkCli
      }

      var selected = null
      if(id !== '') {
        for(var client of global.clients) {
          if(client.id === id) {
            selected = client
            global.currentClient = client.id
            if(client.data.cardId === '' || client.data.cardId === undefined) {
              card = true
            }
            if(client.data.uid !== '') {
              Connector.getClientToken(client.data.uid)
            }
          }
        }
      }

      // Invoice products
      if(item !== null) {
        var ar = item.data.product.split(',')
        for(var a of ar) {
          for(var prod of global.products) {
            if(prod.id === a) {
              product = prod
              products.push(prod)
            }
          }
        }
      }
      
      this.setState({
        clients: global.clients,
        product: product,
        products: products,
        client: selected,
        invoice: invoice,
        item: item,
        back: back,
        card: card
      })
    }
  }


  configureLog() {
    if(this._isMounted) {
      this.setState({
        log: global.userLog
      }, () => {
        if(this.state.loading) {
          for(var item of this.state.log) {
            if(item.data.title === 'chargeerror') {
              EventEmitter.dispatch('showMessageError', item.data.message);
              Firebase.database().ref('/log/'+global.uid+'/'+item.id).remove()
              this.setState({
                loading: false,
              })
            }
            if(item.data.title === 'charge' || item.data.type === 'charge') {
              EventEmitter.dispatch('showMessage', "Payment successful");
              this.setState({
                loading: false,
              })
            }
          }
        }
      })
    }
  }



  // Interactive ------------------------------------------------------------



  setDate(date) {
    this.setState({
      date: date,
      dateChange: true
    })
  }


  checkMakePayment() {
    this.setState({errorCard: [false, false, false, false, false]})
    var tmp = [false, false, false, false, false]
    var passed = true
    var desc = ''
    if(this.state.valuesCard[0] === '') {
      tmp[0] = true
      passed = false
    }
    if(this.state.valuesCard[1] === '') {
      tmp[1] = true
      passed = false;
    }
    if(this.state.valuesCard[2] === '') {
      tmp[2] = true
      passed = false;
    }
    if(this.state.valuesCard[3] === '') {
      tmp[3] = true
      passed = false;
    }
    if(this.state.valuesCard[4] === '') {
      tmp[4] = true
      passed = false;
    }
    this.setState({errorCard: tmp})

    var passed2 = true
    var stock = -1
    for(var product of this.state.products) {
      if(product.data.stock !== undefined && product.data.stock !== -1) {
        if(product.data.stock === 0) {
          passed2 = false
        }
      }
      if(product.data.desc !== '' && product.data.desc !== undefined) {
        desc += product.data.desc+'\n'
      }
    }
    
    if(!passed2) {
      this.setState({
        showModalStock: true
      })
    }

    if(passed && passed2) {
      // Execute payment
      this.setState({
        loading: true,
      })
      var fee = this.state.item.data.price*0.5
      var email = this.state.client.data.email
      if(email === '' || email === undefined) {
        email = 'noemail@ptmate.net'
      }
      this.getPaymentFailsafe()

      if(this.state.client.data.cardId !== '' && this.state.client.data.cardId !== undefined) {
        var callFunction3 = Firebase.functions().httpsCallable('connectedManageClientCardV2');
        callFunction3({type: 'delete', account: global.userStripeConnect, customer: this.state.client.data.customer, card: this.state.client.data.cardId}).then(function(result) {});
      }

      if(this.state.client.data.customer !== '' && this.state.client.data.customer !== undefined) {
        var callFunction = Firebase.functions().httpsCallable('connectedPaymentV2');
        callFunction({type: 'card', account: global.userStripeConnect, clientname: this.state.client.data.name, amount: parseInt(this.state.item.data.price*100), fee: fee, pack: 'Invoice: '+this.state.item.data.number, email: email, name: this.state.valuesCard[0], card: this.state.valuesCard[1], month: this.state.valuesCard[2], year: this.state.valuesCard[3], cvc: this.state.valuesCard[4], customer: this.state.client.data.customer, client: this.state.client.id, date: Moment().format('DD/MM/YYYY HH:mm'), currency: global.userCurrency, ptype: 'other', uid: global.uid, invoice: this.state.item.id, product: 'Invoice: '+this.state.item.data.number, desc: desc, payer: global.uidUser}).then(function(result) {});
      } else {
        var callFunction2 = Firebase.functions().httpsCallable('connectedPaymentV2');
        callFunction2({type: 'account', account: global.userStripeConnect, amount: parseInt(this.state.item.data.price*100), fee: fee, pack: 'Invoice: '+this.state.item.data.number, email: email, name: this.state.valuesCard[0], card: this.state.valuesCard[1], month: this.state.valuesCard[2], year: this.state.valuesCard[3], cvc: this.state.valuesCard[4], clientname: this.state.client.data.name, client: this.state.client.id, date: Moment().format('DD/MM/YYYY HH:mm'), currency: global.userCurrency, ptype: 'other', uid: global.uid, invoice: this.state.item.id, product: 'Invoice: '+this.state.item.data.number, desc: desc, payer: global.uidUser}).then(function(result) {});
      }
    }
  }


  makePayment() {
    var passed = true
    var desc = ''
    for(var product of this.state.products) {
      if(product.data.stock !== undefined && product.data.stock !== -1) {
        if(product.data.stock === 0) {
          passed = false
        }
      }
      if(product.data.desc !== '' && product.data.desc !== undefined) {
        desc += product.data.desc+'\n'
      }
    }
    if(!passed) {
      this.setState({
        showModalStock: true
      })
    }

    if(passed) {
      global.badgeLocked = true
      this.hideModals()
      this.setState({
        loading: true,
      })
      var email = this.state.client.data.email
      if(email === '' || email === undefined) {
        email = 'noemail@ptmate.net'
      }
      this.getPaymentFailsafe()

      var fee = this.state.item.data.price*0.5 //includes *100 calculation
      var callFunction = Firebase.functions().httpsCallable('connectedPaymentV2');
      callFunction({type: 'pay', account: global.userStripeConnect, amount: parseInt(this.state.item.data.price*100), fee: fee, customer: this.state.client.data.customer, client: this.state.client.id, date: Moment().format('DD/MM/YYYY HH:mm'), currency: global.userCurrency, email: email, ptype: 'other', uid: global.uid, invoice: this.state.item.id, product: 'Invoice: '+this.state.item.data.number, pack: 'Invoice: '+this.state.item.data.number, stock: -1, desc: desc, payer: global.uidUser}).then(function(result) {
        //var sanitizedMessage = result.data.text;
      });
    }
  }


  getPaymentFailsafe() {
    setTimeout(() => {
      if(this.state.client !== null && HelperBusiness.getRoleIncl('')) {
        if(this.state.client.id !== undefined && this.state.client.data.customer !== undefined) {
          var callFunction = Firebase.functions().httpsCallable('chargeBackupV2');
          callFunction({type: 'payment', account: global.userStripeConnect, customer: this.state.client.data.customer, client: this.state.client.id}).then(function(result) {});
        }
      }
    }, 100000);
  }


  topUpClient() {
    this.setState({
      loading: false
    })

    var hasCreditGS = false
    var hasCredit11 = false

    var combinedGS = 0
    var combined11 = 0
    var account = ''
    if(this.state.item.data.account !== undefined) {
      account = this.state.item.data.account
    }

    var cgs = {id: '', paid: 0}
    var c11 = {id: '', paid: 0}

    for(var product of this.state.products) {
      var sessions11 = product.data.sessions11
      if(product.data.stype === '11') {
        sessions11 = product.data.sessions
      }

      if(product.data.stock !== undefined && product.data.stock !== -1) {
        if(product.data.stock !== 0) {
          Firebase.database().ref('/packs/'+global.uid+'/'+product.id).update({
            stock: product.data.stock-1
          })
        }
      }

      var expdate = parseInt(Moment().add(product.data.expires, product.data.expType).format('X'))
      if(this.state.dateChange) {
        expdate = parseInt(Moment(this.state.date, 'X').add(product.data.expires, product.data.expType).format('X'))
      }

      if(product.data.type !== 'other') {
        if(product.data.expires !== undefined) {
          var totalGS = 0
          var total11 = 0
          var num = 0
          for(var cred1 of this.state.client.credits) {
            if(cred1.data.group && (product.data.stype === 'both' || product.data.stype === 'group') && cred1.data.sessionsTotal > cred1.data.sessionsPaid && cred1.data.expires === undefined) {
              if(cred1.data.account === account || (cred1.data.account === undefined && account === '')) {
                totalGS = cred1.data.sessionsTotal-cred1.data.sessionsPaid-combinedGS
                if(totalGS > product.data.sessions) {
                  totalGS = product.data.sessions
                }
                if(totalGS < 0) {
                  totalGS = 0
                }
                combinedGS += totalGS
                num = cred1.data.sessionsPaid+combinedGS
                cgs.id = cred1.id
                cgs.paid = num
              }
            }
            if(!cred1.data.group && (product.data.stype === 'both' || product.data.stype === '11') && cred1.data.sessionsTotal > cred1.data.sessionsPaid && cred1.data.expires === undefined) {
              if(cred1.data.account === account || (cred1.data.account === undefined && account === '')) {
                total11 = cred1.data.sessionsTotal-cred1.data.sessionsPaid-combined11
                if(total11 > sessions11) {
                  total11 = sessions11
                }
                if(total11 < 0) {
                  total11 = 0
                }
                combined11 += total11
                num = cred1.data.sessionsPaid+combined11
                c11.id = cred1.id
                c11.paid = num
              }
            }
          }

          if(product.data.stype === 'both' || product.data.stype === 'group') {
            Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits').push({
              sessionsTotal: totalGS,
              group: true,
              sessionsPaid: product.data.sessions,
              type: 'sessions',
              client: this.state.client.id,
              account: account,
              expires: expdate,
              product: product.id,
              name: product.data.name
            })
          }
          if(product.data.stype === 'both' || product.data.stype === '11') {
            Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits').push({
              sessionsTotal: total11,
              group: false,
              sessionsPaid: sessions11,
              type: 'sessions',
              client: this.state.client.id,
              account: account,
              expires: expdate,
              product: product.id,
              name: product.data.name
            })
          }
          
        } else {
          // Check for existing credits
          for(var cred of this.state.client.credits) {
            if(cred.data.group && (product.data.stype === 'both' || product.data.stype === 'group')) {
              if(cred.data.account === account || (cred.data.account === undefined && account === '')) {
                hasCreditGS = true
                var num1 = cred.data.sessionsPaid+product.data.sessions
                Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits/'+cred.id).update({
                  sessionsPaid: num1
                })
              }
            }
            if(!cred.data.group && (product.data.stype === 'both' || product.data.stype === '11')) {
              if(cred.data.account === account || (cred.data.account === undefined && account === '')) {
                hasCredit11 = true
                var num2 = cred.data.sessionsPaid+sessions11
                Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits/'+cred.id).update({
                  sessionsPaid: num2
                })
              }
            }
          }

          // Create new credit entries
          if(!hasCreditGS && (product.data.stype === 'both' || product.data.stype === 'group')) {
            Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits').push({
              sessionsTotal: 0,
              group: true,
              sessionsPaid: product.data.sessions,
              type: 'sessions',
              client: this.state.client.id,
              account: account
            })
          }
          if(!hasCredit11 && (product.data.stype === 'both' || product.data.stype === '11')) {
            Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits').push({
              sessionsTotal: 0,
              group: false,
              sessionsPaid: sessions11,
              type: 'sessions',
              client: this.state.client.id,
              account: account
            })
          }
        }
      }
    }

    if(cgs.id !== '') {
      Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits/'+cgs.id).update({
        sessionsPaid: cgs.paid
      })
    }
    if(c11.id !== '') {
      Firebase.database().ref('/clients/'+global.uid+'/'+this.state.client.id+'/credits/'+c11.id).update({
        sessionsPaid: c11.paid
      })
    }

    global.message = lang.t('messaging:message.paymentsuccessful')
    var link = global.currentPage
    if(global.linkCli !== '') {
      link = global.linkCli
    }
    this.props.history.push(link)
  }


  logCashPayment() {
    var passed = true
    var stock = -1
    for(var product of this.state.products) {
      if(product.data.stock !== undefined && product.data.stock !== -1) {
        if(product.data.stock === 0) {
          passed = false
        } else {
          stock = product.data.stock-1
        }
      }
    }

    if(!passed) {
      this.setState({
        showModalStock: true
      })
    }

    if(passed) {
      var date = Moment().format('DD/MM/YYYY HH:mm')
      if(this.state.dateChange) {
        date = Moment(this.state.date, 'X').format('DD/MM/YYYY HH:mm')
      }
      global.badgeLocked = true
      var obj = Firebase.database().ref('/payments/'+global.uid).push()
      obj.set({
        amount: this.state.item.data.price*100,
        client: this.state.client.id,
        fee: 0,
        id: obj.key,
        date: date,
        last4: '',
        name: 'Invoice: '+this.state.item.data.number,
        receipt: '',
        refunds: '',
        type: 'Cash',
        notes: this.state.notes,
        uid: global.uidUser,
        payer: global.uidUser
      })

      // update stock here
      if(stock !== -1) {
        Firebase.database().ref('/packs/'+global.uid+'/'+product.id).update({
          stock: stock
        })
      }

      if(global.showHabits) {
        var arr = []
        var address = ''
        if(global.spaceAddress !== undefined) {
          arr = global.spaceAddress.split('||')
          if(arr.length > 3) {
            address = arr[0]+'\n'+arr[1]+'\n'+arr[2]+', '+arr[3]
          }
        }
        if(global.spaceInvoice1 !== undefined && global.spaceInvoice1 !== '') {
          address = global.spaceInvoice1
        }
        var gst1 = ''
        var gst2 = ''
        if(this.state.item.data.gst !== 0 && this.state.item.data.gst !== undefined) {
          gst1 = lang.t('messaging:label.gstincluded')
          gst2 = global.curSym+this.state.item.data.gst.toFixed(2)
        }
        var desc = ''
        for(var product of this.state.products) {
          if(product.data.desc !== undefined) {
            desc += product.data.desc+'\n'
          }
        }
        
        var callFunction = Firebase.functions().httpsCallable('sendReceiptV2');
        callFunction({name: global.userBusiness, email: this.state.client.data.email, address: address, number: obj.key, date: Moment().format('D MMM YYYY - HH:mm'), businessemail: global.spaceEmail, phone: global.spacePhone, product: 'Invoice '+this.state.item.data.number, price: global.curSym+(this.state.item.data.price.toFixed(2)), method: 'Other payment method', gst1: gst1, gst2: gst2, desc: desc}).then(function(result) {});
      }
      if(this.state.invoice !== '') {
        Firebase.database().ref('/invoices/'+global.uid+'/'+this.state.invoice).update({
          status: 'paid'
        })
      }
      
      setTimeout(() => {
        EventEmitter.dispatch('updateBadges', 'payment');
      }, 1000);
      this.topUpClient()
    }
  }



  // Modals ------------------------------------------------------------



  hideModals() {
    this.setState({
      showModalClients: false,
      showModalBasic: false,
      showModalConfirm: false,
      showModalStock: false,
    })
  }


  modalClick(item) {
    this.hideModals()
    var card = false
    if(item.data.cardId === '' || item.data.cardId === undefined) {
      card = true
    }
    this.setState({
      client: item,
      card: card
    })
    if(item.data.uid !== '') {
      Connector.getClientToken(item.data.uid)
    }
  }



  // Display stuff ------------------------------------------------------------



  renderBottomButton() {
    if(global.userStripeConnect === undefined || global.userStripeConnect === '') {
      return (
        <div>
          <div className="sv-20"></div>
          <div className="infobox yellow">
            <h5>{lang.t('billing:enable.title')}</h5>
            <p className="mb-20">{lang.t('billing:enable.text')}</p>
            <Link to={ROUTES.ACCOUNTBILLING} className="btn tertiary width-12 small" style={{textDecoration: 'none'}}>{lang.t('billing:enable.button')}</Link>
          </div>
        </div>
      )
    } else {
      return (
        this.renderBottom()
      )
    }
  }


  renderBottom() {
    if(this.state.client !== null) {
      if(this.state.card) {
        return (
          <div className="mt-20">
              <FormCard values={this.state.valuesCard} error={this.state.errorCard} onChange={(event) => this.setState({valuesCard: event})}/>
              <div className="sv-40 clear"></div>
              <button className="btn primary mb-10" onClick={() => this.checkMakePayment()}>{lang.t('billing:button.paywithcard')}</button>
              <p className="small center secondary">{lang.t('billing:form.cardsaved')}<br/>{lang.t('billing:form.paymentfee')}: {global.stripeFee}</p>
          </div>
        )
      } else {
        return (
          <div>
            <div className="paymethod mt-10 mb-30">
              <WidgetCard id={this.state.client.id}/>
              <p style={{whiteSpace: 'pre-wrap'}}>{lang.t('billing:form.info.existingcard')}</p>
            </div>
            <button className="btn tertiary add width-12" onClick={() => this.setState({card: true})}>{lang.t('billing:button.useanothercard')}</button>
            <div className="sv-50"></div>
            <button className="btn primary mb-10" onClick={() => this.setState({showModalConfirm: true})}>{lang.t('billing:button.paywithcard')}</button>
            <p className="small center secondary">Payment fee: {global.stripeFee}</p>
          </div>
        )
      }
    }
  }


  renderSelect() {
    if(this.state.method === 'card') {
      return (
        <div>
          <div className="space-40"></div>
          <InputRadio
            value={this.state.method}
            clickElement={(event) => this.setState({method: event})}
            values={[{name: lang.t('billing:form.cardpayment'), value: 'card'}, {name: lang.t('billing:form.othermethod'), value: 'cash'}]}
          />
          {this.renderBottomButton()}
        </div>
      )
    } else {
      return (
        <div>
          <div className="space-40"></div>
          <InputRadio
            value={this.state.method}
            clickElement={(event) => this.setState({method: event})}
            values={[{name: lang.t('billing:form.cardpayment'), value: 'card'}, {name: lang.t('billing:form.othermethod'), value: 'cash'}]}
          />
          <div className="paymethod mt-10 mb-10">
            <p>{lang.t('billing:form.info.logpayment')}</p>
          </div>
          <div className="sv-20"></div>
          <InputDate label={lang.t('billing:form.paymentdate')} value={Moment(this.state.date, 'X').format('YYYY-MM-DD')} format='YYYY-MM-DD' min={Moment().add(-50, 'days').format('YYYY-MM-DD')} max={Moment().add(1, 'months').format('YYYY-MM-DD')} onChange={(event) => this.setDate(Moment(event).format('X'))}/>
          <InputText label={lang.t('billing:form.notes')} value={this.state.notes} onChange={(event) => this.setState({notes: event})}/>
          <div className="sv-20"></div>
          <button className="btn primary" onClick={() => this.logCashPayment()}>{lang.t('billing:button.logpayment')}</button>
        </div>
      )
    }
  }


  renderBottomCheck() {
    if(this.state.client !== null) {
      if(this.state.item.data.price === 0) {
        return (
          <div>
            <div className="paymethod mt-10">
              <p>{lang.t('billing:form.info.topup1')} {global.curSym}0. {lang.t('billing:form.info.topup2')}</p>
            </div>
            <div className="sv-50"></div>
            <button className="btn primary mb-10" onClick={() => this.topUpClient()}>{lang.t('billing:button.topupclient')}</button>
          </div>
        )
      } else {
        return (
          this.renderSelect()
        )
      }
    }
  }


  renderGST() {
    if(this.state.item.data.gst !== 0 && this.state.item.data.gst !== undefined) {
      return <p className="clear">GST incl.<span style={{float:'right'}}>{global.curSym}{this.state.item.data.gst.toFixed(2)}</span></p>
    }
  }


  renderProducts() {
    return (
      <div className="info">
        <label>Items</label>
        <div className="sv-10"></div>
        {this.state.products.map(item => (
          <p className="clear">{item.data.name}<span style={{float:'right'}}>{global.curSym}{item.data.price.toFixed(2)}</span></p>
        ))}
        {this.renderGST()}
        <div style={{height: 10, borderBottom: '1px solid #d1d4df'}}></div>
        <div className="sv-10"></div>
        <p className="clear">Total<span style={{float:'right'}}>{global.curSym}{this.state.item.data.price.toFixed(2)}</span></p>
      </div>
    )
  }


  renderBase() {
    if(HelperBusiness.getRoleIncl('trainer,admin')) {
      if(this.state.item !== null) {
        return (
          <div className={'theme-'+global.spaceTheme}>
            <div className="content form-sidebar">
              <div className="col-6 mt-20">
                <div className="box">
                  <InputClient id='payment' client={this.state.client} clickElement={() => this.setState({showModalClients: false})}/>
                  <div className="sv-20"></div>
                  {this.renderProducts()}
                  <div className="sv-20"></div>
                  {this.renderBottomCheck()}
                </div>
              </div>
              <div className="col-6 mt-20">
                <div className="sidebar">
                  <WidgetFormInfo id={'payinvoice'}/>
                </div>
              </div>
              <div className="clear sv-20"></div>
            </div>
            <Header title={'Pay Invoice '+this.state.item.data.number} link={this.state.back}/>
            <Navigation active='billing' />
            <ModalMessageSimple type='confirmpay' show={this.state.showModalConfirm} var={this.state.client === null ? '' : this.state.client.data.name} onHide={() => this.hideModals()} clickMainButton={() => this.makePayment()}/>
            <ModalMessageSimple type='nostock' show={this.state.showModalStock} onHide={() => this.hideModals()} clickMainButton={() => this.hideModals()}/>
            <Loader show={this.state.loading}/>
          </div>
        )
      } else {
        return (
          <div className={'theme-'+global.spaceTheme}>
            <div className="content form-sidebar">
              <div className="col-6 mt-20">
                <div className="box">
                  <InputClient id='payment' client={this.state.client} clickElement={() => this.setState({showModalClients: false})}/>
                </div>
              </div>
              <div className="col-6 mt-20">
                <div className="sidebar">
                  <WidgetFormInfo id={'payinvoice'}/>
                </div>
              </div>
              <div className="clear sv-20"></div>
            </div>
            <Header title={'Pay Invoice'} link={this.state.back}/>
            <Navigation active='billing' />
          </div>
        )
      }
    } else {
      return (
        <div className={'theme-'+global.spaceTheme}>
          <div className="content">
            <ListEmpty id='payment-locked' type='simple'/>
          </div>
          <Header title={'Pay Invoice'} link={this.state.back}/>
          <Navigation active='billing' />
        </div>
      )
    }
    
  }


  render() {
    return (
      <AuthUserContext.Consumer>
        {authUser => (
          this.renderBase()
        )}
      </AuthUserContext.Consumer>
    )
  }
}



const condition = authUser => !!authUser;
export default withTranslation(['billing','common','header','messaging'])(withRouter(withAuthorization(condition)(PayInvoicePage)));